import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { orderArrayByProperty, valuesToArray } from "../../../util/arraysUtil";
import { getFormattedDate } from "../../../util/dates";
import Container from "../../../ui/Container/Container";
import Button from "../../../ui/Button/Button";
import "./Results.css";

function Results() {
  const location = useLocation();
  const data = location.state.patient;
  const key = location.state.key;
  const navigateTo = location.state.navigateTo;
  const patientKey = location.state.patientKey;
  const patients = location.state.patients;
  const doctor = location.state.doctor;
  const navigate = useNavigate();
  let answers = data.questionaries[key]
    ? orderArrayByProperty(data.questionaries[key].answers, "key")
    : undefined;

  function RenderFullQuestion({ question, answer }) {
    return (
      <div className="resultMainAnswer">
        <p className="resultsQuestion">{question}</p>
        <p className="resultsAnswer">{answer}</p>
      </div>
    );
  }

  function renderAnswers(item) {
    let answer;
    switch (item.type) {
      case "multi":
        answer = valuesToArray(item.answer).toString();
        break;
      case "date":
        if (item.answer === "NA") {
          answer = item.answer;
        } else {
          answer = getFormattedDate(new Date(item.answer));
        }
        break;
      default:
        answer = item.answer;
        break;
    }
    return (
      <RenderFullQuestion
        key={item.key}
        question={item.question}
        answer={answer}
      />
    );
  }

  return (
    <Container title="Respuestas">
      <div className="resultsAnswers">
        {answers &&
          answers.map((a) => {
            return renderAnswers(a);
          })}
        {!answers && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              alignItems: "center",
              color: "#F27059",
              fontSize: "24px",
            }}
          >
            Aún no hay respuestas para este cuestionario
          </div>
        )}
      </div>
      <div style={{ marginTop: "10px", justifyItems: "center" }}>
        <div className="resultsButtons">
          <Button
            onPress={() => {
              const state =
                navigateTo === "/adminPatientInfo"
                  ? { state: { data, patients, doctor } }
                  : { state: { patientKey } };
              navigate(navigateTo, state);
            }}
          >
            OK
          </Button>
        </div>
      </div>
    </Container>
  );
}

export default Results;
